
interface ProductFeaturesProps {
  features: string[];
}

export default function ProductFeatures({ features }: ProductFeaturesProps) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Key Features</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Advanced manual call points designed for reliable fire alarm activation in all environments
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start gap-4 p-6 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
              <div className="w-8 h-8 bg-red-600 text-white rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-sm"></i>
              </div>
              <div>
                <p className="text-gray-900 font-medium leading-relaxed">{feature}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl p-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">QCDD Approved & EN54 Certified</h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              All our manual call points meet Qatar Civil Defence Department standards and European EN54 certification requirements, ensuring reliable performance and regulatory compliance.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
